import { FC } from "react";
import { IconPropsType } from ".";

export const Tip: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93082 1.36562C8.93082 0.970233 8.67898 0.75 8.36832 0.75C8.05766 0.75 7.80582 0.970233 7.80582 1.36562L7.80582 2.52471H6.68083C6.22896 2.52471 6 2.77655 6 3.08721C6 3.39787 6.22896 3.64971 6.68083 3.64971H7.80582L7.80582 4.91719C7.80582 5.31257 8.05766 5.5247 8.36832 5.5247C8.67898 5.5247 8.93082 5.31257 8.93082 4.91719L8.93082 3.64971H9.98792C10.4398 3.64971 10.6463 3.39787 10.6463 3.08721C10.6463 2.77655 10.4398 2.52471 9.98792 2.52471H8.93082L8.93082 1.36562Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 8.25C6.25 9.09793 6.0412 9.80507 5.76912 10.2585C5.48212 10.7369 5.25975 10.75 5.25 10.75C5.24025 10.75 5.01788 10.7369 4.73088 10.2585C4.4588 9.80507 4.25 9.09793 4.25 8.25C4.25 7.40207 4.4588 6.69493 4.73088 6.24147C5.01788 5.76313 5.24025 5.75 5.25 5.75C5.25975 5.75 5.48212 5.76313 5.76912 6.24147C6.0412 6.69493 6.25 7.40207 6.25 8.25ZM7.5 8.25C7.5 10.3211 6.49264 12 5.25 12C5.24654 12 5.24308 12 5.23962 12L5.19355 12C4.51878 12.0004 3.59915 12.0009 2.85417 11.5353C2.45026 11.2828 2.10077 10.8987 1.85861 10.3378C1.62063 9.78658 1.5 9.09711 1.5 8.25C1.5 7.40289 1.62063 6.71342 1.85861 6.16222C2.10077 5.60133 2.45026 5.21718 2.85417 4.96474C3.59915 4.49913 4.51878 4.49964 5.19355 4.50002L5.23961 4.50004C5.24307 4.50001 5.24653 4.5 5.25 4.5C6.49264 4.5 7.5 6.17893 7.5 8.25ZM3.44177 6.01801C3.16419 6.64164 3 7.41386 3 8.25C3 9.08614 3.16419 9.85836 3.44177 10.482C3.41404 10.4663 3.38682 10.4501 3.36012 10.4334C3.13903 10.2952 2.9528 10.0935 2.8155 9.77546C2.67402 9.44776 2.57143 8.96538 2.57143 8.25C2.57143 7.53462 2.67402 7.05224 2.8155 6.72454C2.9528 6.40654 3.13903 6.20476 3.36012 6.06658C3.38682 6.04989 3.41404 6.0337 3.44177 6.01801Z"
        fill={props.color}
      />
    </svg>
  );
};
